<template>
  <Modal 
    v-if="displaySuccess" 
    :config='modalConfig.confirmAddPayee'
    @btn2Action="$emit('closePayeeSuccess')">
  </Modal>
</template>
<script>

import Modal from '@/components/common/Modal.vue'

export default {
  name: 'LocalPaymentsAddPayeeSuccess',
  props: {
    displaySuccess: Boolean
  },
  components: {
    Modal
  },
  data () {
    return {
      modalConfig: {
        confirmAddPayee: {
          enabled: true,
          title: this.$t("internationalPayments.addPayeeSuccessMsg"),
          persistent: true,
          saveButton: this.$t('common.okay'),
          btn2Label: this.$t('common.okay'),
          width: 500
        }
      }
    }
  }
}
</script>
